package ir.alirezaivaz.finglish.utils

object FinglishConverter {

    private val dictionary = FinglishDictionary()

    fun convert(text: String): String {
        return Regex("\\S+|\\s+").findAll(text).joinToString("") { match ->
            val word = match.value

            if (word.isBlank()) {
                // Keep spaces and new lines
                word
            } else {
                // Extract core letters for dictionary (ignore symbols at start/end)
                val core = word.trim { !dictionary.isPersianLetterOrMark(it) }
                    .map { dictionary.normalize(it) }
                    .joinToString("")

                // Dictionary override
                val convertedCore = dictionary.getWord(core)

                // Preserve prefix/suffix symbols
                if (word.all { !dictionary.isPersianLetterOrMark(it) }) {
                    // word is only symbols → convert once
                    word.map { dictionary.getSymbol(it) }.joinToString("")
                } else {
                    // normal word with prefix/suffix
                    val prefix = word.takeWhile { !dictionary.isPersianLetterOrMark(it) }
                        .map { dictionary.getSymbol(it) }.joinToString("")
                    val suffix = word.takeLastWhile { !dictionary.isPersianLetterOrMark(it) }
                        .map { dictionary.getSymbol(it) }.joinToString("")
                    prefix + convertedCore + suffix
                }
            }
        }
    }
}
